// 单文件引入方式

import ZuiRedDot from './ZuiRedDot.vue'

export default function install(Vue) {
  Vue.component('ZuiRedDot', ZuiRedDot)
}
